export const AWS_REGIONS = {
  EU_CENTRAL_1: 'eu-central-1',
  US_EAST_1: 'us-east-1',
};

export const DEFAULT_LAMBDA_FUNCTION_NAME = 'hub2-db-1-node-24';

const US_EAST_1_LAMBDA_FUNCTIONS = new Set([
  'hub2-csv-to-xlsx-converter',
  'hub2-db-general-us-east',
  'hub2-db-general-node-20',
  'hub2-db-general-us-east-node-24',
  'hub2-db-1',
  'hub2-db-1-node-24',
  'hub2-db-2',
  'hub2-db-3',
  'hub2-db-oog',
  'hub2-digital-ad-handler',
  'hub2-impression-handler',
  'hub2-impression-parser',
  'test-hub2-db-oog',
  'media-handler',
  'hub2-xlsx-handler',
  'hub2-actualized-reports-handler',
  'hub2-playlist-export',
  'hub2-advertiser-statistic',
  'hub2-contact-parser',
  'hub2-report-mailer',
  'hub2-dashboard-export',
]);

export const getLambdaRegion = (functionName) =>
  US_EAST_1_LAMBDA_FUNCTIONS.has(functionName)
    ? AWS_REGIONS.US_EAST_1
    : AWS_REGIONS.EU_CENTRAL_1;

export const LONG_LAMBDA_TIMEOUT_MS = 899_000;